import { scaleBand, pointer, select } from "d3";
import { addDays } from "date-fns";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { saveMaquinaGanttPosition } from "../../services/charts.service";
import { DatasEntregas } from "./DatasEntregas";

import { MaquinasBars } from "./MaquinasBars";
import { Tooltip } from "./Tooltip";
import { tickerFormatter } from "./utils/timeFormatters";




export function EntregasBars({maquinasBarHeight, entregas, xScale, yScale, obraBarHeight, margins} : any) {



    const maquinasScale = (maquinas: any[], y0: number, y1: number) => scaleBand()
    .domain(maquinas.map((e: any) => {
        return e.maquina.id;
    } ))
    .range([y0, y1])


    const [maquinasTimelines, setMaquinasTimelines] = useState<any>(entregas.map((e: any) => e.maquinasGantt.map((m : any) => {
        const start = new Date(m.startUsageDate);
        const end = new Date(m.endUsageDate);

        return {
            start: xScale(start),
            end: xScale(end)
        }
    }))) 



    const [draggedBar, setDraggedBar] = useState<any>({entrega: null, maquina: null, border: null});

    const [toolTip, setTooltip] = useState(false);

    const [mousePosition, setMousePosition] = useState({x: 0, y: 0});

 
    const onMouseMove = (e : any) => {
        e.stopPropagation();
        // console.log("Dragged bar: ", draggedBar);
        if(draggedBar.entrega != null && draggedBar.maquina != null && draggedBar.border != null) {
            setTooltip(true);

            setMousePosition({...{x: pointer(e)[0], y: pointer(e)[1]}});

            const obj = maquinasTimelines;
            obj[draggedBar.entrega][draggedBar.maquina][draggedBar.border] = pointer(e)[0]
           
            setMaquinasTimelines({...obj});
        } 
    }

    const  saveNewPosition = async (maquinaGanttId: number, data: any) => {
        await toast.promise(
            (async () => {
                await saveMaquinaGanttPosition(maquinaGanttId, data)
            })()
            , {
                success: (t: any) => (
                    <span>
                        <span>Utilização de máquina atualizada com sucesso</span>
                    </span>
                ),
                error: ({ response }: any) => (
                    <span>
                        <span>Erro ao atualizar utilização de máquina <p>{response.data.error}</p></span>
                    </span>
                ),
                duration: 2000
            } as any
        )
    }

    const onMouseUp = async (e: any) => {
        if(maquinasTimelines[draggedBar.entrega]) {
            const dateString = draggedBar.border == 'end'  ?
            addDays(xScale.invert(maquinasTimelines[draggedBar.entrega][draggedBar.maquina][draggedBar.border]), 1).toISOString().split('T')[0] :
            xScale.invert(maquinasTimelines[draggedBar.entrega][draggedBar.maquina][draggedBar.border]).toISOString().split('T')[0];
   
           await saveNewPosition(draggedBar.maquinaGanttId, {position: draggedBar.border, newDate: dateString})
   
           setDraggedBar({entrega: null, maquina: null, border: null, maquinaGanttId: null});
           setTooltip(false);
        }
        
    }

    const buildTooltipMessage = () => {
        const prefix = draggedBar.border == 'start' ? `Em utilização a partir de: ` : `Em utilização até: ` 
        return `${prefix} ${tickerFormatter(xScale.invert(mousePosition.x).getTime())}`
    }

    return( <>
        {entregas.map((entrega: any, idx: number) => {

                const start = entrega.startingDate;
                const end = entrega.realDeliveryDate;

                const ganttMachines = entrega.maquinasGantt;
                const uniqueMachines = [...new Set(ganttMachines.map((mg : any) => mg.maquina.id))];
                const entregasBarHeight = maquinasBarHeight * uniqueMachines.length;


                return(<g transform={`translate(0,${margins.top})`} key={entrega.id} onMouseMove={onMouseMove} onMouseUp={(e: any) => onMouseUp(e)}>
                        
                    
                    <rect
                        className="fill-white opacity-60"
                        x={xScale(start)}
                        y={yScale(entrega.id) }
                        width={xScale( end) - xScale(start)}
                        height={entregasBarHeight}
                        stroke={'black'}
                        strokeWidth={1}
                     
                    />
                    <DatasEntregas entrega={entrega} entregaBarHeight={entregasBarHeight} xScale={xScale} y={yScale(entrega.id) }/>
                
                    <MaquinasBars
                        entregaIdx={idx}
                        maquinasBarHeight={maquinasBarHeight}
                        setDraggedBar={setDraggedBar}
                        maquinasTimelines={maquinasTimelines[idx]}
                        maquinas={ganttMachines}
                        yScale={maquinasScale(ganttMachines, yScale(entrega.id), yScale(entrega.id) + maquinasBarHeight * uniqueMachines.length)}/>

                    {toolTip?
                        <Tooltip width={220} height={30} size={'xs'} message={buildTooltipMessage()} x={mousePosition.x} y={mousePosition.y}/>
                    : null}

                    </g>
                )

        })}
      
        
    </> )


}